import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    options: {
      showIcon: true,
      showFrequencies: true
    }
  },
  mutations: {
    setShowIcon(state, setting) {
      state.options.showIcon = setting;
    },
    setShowFrequencies(state, setting) {
      state.options.showFrequencies = setting;
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [new VuexPersistence().plugin]
})
